/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { findListingEntity } from './helpers/entityReadHelpers';
import { removeListingVariant, upsertListing } from './helpers/entityAdapter';
import { setSelectedChannelByProduct } from './helpers/uiAdapter';

export const deleteVariantLiveSnapshot = createAsyncThunk(
  'products/deleteVariantLiveSnapshot',
  async ({ masterProductId, channelId, variantId }, { extra: { Logger, Toast, sdk } }) => {
    try {
      await sdk.products.deleteVariant(variantId);
      return { masterProductId, channelId, variantId };
    } catch (error) {
      Toast('Cannot remove variant from listing. Refresh and try again', { type: 'error', autoClose: false });
      Logger.error(new Error('Error deleting live variant from listing'), { error }, [
        'DeleteVariantLiveSnapshotFailed',
        { errorMessage: 'Live variant not deleted on backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(deleteVariantLiveSnapshot.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(deleteVariantLiveSnapshot.fulfilled, (state, { payload }) => {
      const { masterProductId, channelId, variantId } = payload;
      state.isBusy = false;

      const existingListing = findListingEntity(state, { masterProductId, channelId });
      removeListingVariant(state, variantId);

      if (existingListing?._id && existingListing.live) {
        upsertListing(state, {
          ...existingListing,
          masterProductId,
          live: {
            ...existingListing.live,
            variants: (existingListing.live.variants || []).filter(({ _id }) => _id !== variantId),
          },
        });
      }

      setSelectedChannelByProduct(state, masterProductId, 'master');
    })
    .addCase(deleteVariantLiveSnapshot.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot delete variant live snapshot';
    });
};
